/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Too_LongInputs */

const en_site_url_error_too_long = /** @type {(inputs: Site_Url_Error_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That address is too long.`)
};

const id_site_url_error_too_long = /** @type {(inputs: Site_Url_Error_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamatnya terlalu panjang.`)
};

/**
* | output |
* | --- |
* | "That address is too long." |
*
* @param {Site_Url_Error_Too_LongInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_too_long = /** @type {((inputs?: Site_Url_Error_Too_LongInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Too_LongInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_too_long(inputs)
	return en_site_url_error_too_long(inputs)
});